const featureItems = [
  {
    icon: 'ri-database-2-line',
    title: '内容全面',
    desc: '覆盖娱乐圈、网红、综艺、影视、体育、国际等 15+ 频道，海量吃瓜内容一站式聚合。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '更新快速',
    desc: '7×24 小时全天候追踪热点，重大事件第一时间上线，日更资讯超过 500 条。',
  },
  {
    icon: 'ri-layout-grid-line',
    title: '分类清晰',
    desc: '按话题、热度、时间多维度智能分类，一键触达你关心的吃瓜专题页面。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    desc: '官方认证入口直达，无需注册登录，所有内容免费开放浏览，访问安全有保障。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '体验流畅',
    desc: '全面适配桌面与移动端，页面加载迅速，操作简洁直观，畅快吃瓜无阻碍。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            平台特色
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            为什么千万瓜友选择五一吃瓜网作为每日吃瓜首选入口
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
          {featureItems.map((item, idx) => (
            <div
              key={idx}
              className="group flex flex-col items-center text-center p-5 md:p-6 bg-background-100 rounded-2xl border border-background-200/70 hover:border-primary-200/70 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-100/70 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-800 mb-2 whitespace-nowrap">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}